import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { IState } from '../../../shared/models/state';
import { Actions } from '@ngrx/effects';
import { GET_INVOICES_SUCCESS, GetInvoicesAction } from './invoices.action';

@Injectable()
export class InvoicesResolve implements Resolve<any> {
  constructor(private store: Store<IState>, private action$: Actions) {}

  resolve() {
    this.store.dispatch(new GetInvoicesAction());
    return this.action$.ofType(GET_INVOICES_SUCCESS).take(1);
  }
}
